import { render, staticRenderFns } from "./OrderFlowStepPolisInformation.vue?vue&type=template&id=2588ab2a&scoped=true&"
import script from "./OrderFlowStepPolisInformation.vue?vue&type=script&lang=js&"
export * from "./OrderFlowStepPolisInformation.vue?vue&type=script&lang=js&"
import style0 from "./OrderFlowStepPolisInformation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderFlowStepPolisInformation.vue?vue&type=style&index=1&id=2588ab2a&scoped=true&lang=css&"
import style2 from "./OrderFlowStepPolisInformation.vue?vue&type=style&index=2&id=2588ab2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2588ab2a",
  null
  
)

export default component.exports